// Modules
import { eventChannel } from 'redux-saga'
import { call, put, take, takeEvery } from 'redux-saga/effects'

import {
  wsCurrencyMarketChangeCurrencyValue,
  wsCurrencyMarketMessageReceived,
  wsCurrencyMarketMessageReceivedUpdateGlobalList,
} from 'store/actions/CurrencySocket/actions'
import {
  WS_CONNECT_CURRENCY_MARKET,
  WS_DISCONNECT_CURRENCY_MARKET,
} from 'store/actions/CurrencySocket/types'
import { URL_SOCKET_PATH, WS_PORT } from 'store/api'

// Constants
const TYPE_CLOSE = 'CLOSE'
const TYPE_ERROR = 'ERROR'
const TYPE_MESSAGE = 'MESSAGE'
const TYPE_OPEN = 'OPEN'

function* handleMessages(action) {
  yield put(wsCurrencyMarketMessageReceived(action.payload))
  yield put(wsCurrencyMarketMessageReceivedUpdateGlobalList(action.payload))

  // update the visible accordion panel immediately, in sync with the chart
  if (action?.type === TYPE_MESSAGE) {
    yield put(wsCurrencyMarketChangeCurrencyValue(action.payload))
  }
}

export function* watchCurrencyMarketWebSocket() {
  while (true) {
    const { options } = yield take(WS_CONNECT_CURRENCY_MARKET)
    const socket = yield call(connectWebSocket, options)
    yield takeEvery(socket, handleMessages)
    yield take(WS_DISCONNECT_CURRENCY_MARKET)
    socket.close()
  }
}

function connectWebSocket(options) {
  return eventChannel((emitter) => {
    const prepareStrForSocket = createSocketQueryString(options)
    if (!prepareStrForSocket) {
      return () => {}
    }

    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
    const socket = new WebSocket(
      `${protocol}://${URL_SOCKET_PATH}:${WS_PORT}?${prepareStrForSocket}&interval=${
        options?.intervalGraph || '1D'
      }`,
    )

    socket.onopen = () => emitter({ type: TYPE_OPEN })
    socket.onmessage = (event) => emitter({ type: TYPE_MESSAGE, payload: JSON.parse(event.data) })
    socket.onclose = () => emitter({ type: TYPE_CLOSE })
    socket.onerror = (error) => emitter({ type: TYPE_ERROR, payload: error })

    // Return unsubscribe function to close the socket
    return () => socket.close()
  })
}

// Helper function to create query string for WebSocket URL
function createSocketQueryString(options) {
  const { group, channels, groupLimit } = options

  if (!group || !channels) return ''

  let queryString = `groups[]=${encodeURIComponent(group)}`
  queryString += channels.map((channel) => `&channels[]=${encodeURIComponent(channel)}`).join('')

  if (groupLimit) {
    queryString += `&groupLimit=${encodeURIComponent(groupLimit)}`
  }

  return queryString
}
